@let labelTranslated = label() ?? '' | translate;

<button
    [id]="id()"
    class="custom-button  {{ type() }} {{ color() }}"
    [attr.title]="title || labelTranslated"
    [class.loading-inside]="loading()"
    [class.fill]="fill()"
    [class.fill-start]="fillStart()"
    [class.selected]="active()"
    [class.xs]="size() === 'xs'"
    [class.small]="size() === 'sm'"
    [class.medium]="size() === 'md'"
    [class.large]="size() === 'lg'"
    [class.icon-only]="iconOnly()"
    [class.icon-only-no-padding]="iconOnlyNoPadding()"
    [class.custom-padding]="customPadding()"
    [class.remove-hover]="removeHover()"
    [class.text-uppercase]="textUppercase()"
    [class.font-bold]="!removeBold()"
    [class.one-line]="oneLine()"
    [class.text-base]="!fontSizeSm() && !fontSizeLg()"
    [class.text-sm]="fontSizeSm()"
    [class.text-lg]="fontSizeLg()"
    [class.rounded-md]="borderRadiusMd()"
    [class.icon-right]="iconRight()"
    [class.full-width]="fullWidth()"
    [class.align-start]="alignStart()"
    [class.disabled]="disabled() || loading() || loading() || timeDisabledDuration()"
    [class.has-border]="hasBorder()"
    [badgeDisabled]="!badge()"
    [value]="badge()!"
    [pTooltip]="labelTranslated"
    [tooltipPosition]="tooltipPosition()"
    [tooltipDisabled]="!iconOnly() || !label()"
    [(timeDisabledDuration)]="timeDisabledDuration"
    pBadge
    severity="info"
    #button>
    @if ((!iconRight() && icon()) || (loading() && !iconRight())) {
        <icon
            [name]="loading() ? 'spinner' : icon()!"
            [size]="_iconSize()"
            [customColor]="textColor()"
            [rotate]="iconRotate()"
            [class.mr-item-sm]="!iconOnly()"
            [class.pi-spin]="loading()" />
    }

    @if (!iconOnly()) {
        <div class="flex flex-row justify-start items-center z-10">
            {{ label() ?? '' | translate }}
            @if (count() > -1) {
                ({{ count() }})
            }
            <ng-content></ng-content>
        </div>
    }

    @if ((iconRight() && icon()) || (loading() && iconRight())) {
        <icon
            [name]="loading() ? 'spinner' : icon()!"
            [size]="_iconSize()"
            [customColor]="textColor()"
            [rotate]="iconRotate()"
            [class.ml-item-sm]="!iconOnly()"
            [class.pi-spin]="loading()" />
    }
</button>
